import { Card, CardContent, Typography, Box } from '@mui/material';
import { useFinancialDashboardResource } from './hooks/useFinancialDashboardResource';

export function AvailableCashBalance({ selectedDate, viewByYear, viewAllPeriod }) {
  const { data: balance } = useFinancialDashboardResource(
    '/financial/dashboard/available-cash-balance',
    { selectedDate, viewByYear, viewAllPeriod },
    0,
  );

  const isPositive = balance >= 0;

  return (
    <Card
      elevation={3}
      sx={{
        borderRadius: 4,
        minWidth: 280,
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary">
          Saldo Disponível em Caixa
        </Typography>

        <Box mt={1}>
          <Typography
            variant="h4"
            fontWeight="bold"
            color={isPositive ? 'success.main' : 'error.main'}
          >
            {balance.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
        </Box>

        <Typography variant="caption" color="text.secondary">
          {viewByYear ? 'Resultado do ano' : 'Resultado do mês'}
        </Typography>
      </CardContent>
    </Card>
  );
}
